import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterByComponent } from './filter-by.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [FilterByComponent],
  imports: [CommonModule, InlineSVGModule, NgbModule],
  exports: [FilterByComponent],
})
export class FilterByModule {}
